import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)


import * as util from '@/views/utils/utilsFunctions'

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  colorSideBar: {
        hex: '#7E1146',
        hex8: '#7E1146',
        hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
        hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
        rgba: { r: 25, g: 77, b: 51, a: 1 },
        a: 1
    },
  colorHeadeBar: {
      hex: '#fff',
      hex8: '#fff',
      hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
      hsv: { h: 150, s: 0.66, v: 0.30, a: 1 },
      rgba: { r: 25, g: 77, b: 51, a: 1 },
      a: 1
  },
  colorIconoBar: '#29235C',
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  changeColorSideBar(state, value){
    state.colorSideBar = value
    document.documentElement.style.setProperty('--main-color', value.hex8);
    document.documentElement.style.setProperty('--color-hijo', value.hex8);
    document.documentElement.style.setProperty('--color-padre', value.hex8);
    document.documentElement.style.setProperty('--color-sidebar', value.hex8);
    let luminancia = util.calcularLuminancia(state.colorSideBar.hex8);
    if (luminancia > 0.2) {
      document.documentElement.style.setProperty('--color-letra', '#29235C');
    } else {
      document.documentElement.style.setProperty('--color-letra', '#ffffffcc');
    }
  },
  changeColorHeadeBar(state, value){
    state.colorHeadeBar = value
    let luminancia = util.calcularLuminancia(state.colorHeadeBar.hex8);
    state.colorIconoBar =  luminancia > 0.2 ? '#29235C' : 'white';
  },
  
  set (state, [variable, value]) {
    state[variable] = value
  }
}

export default new Vuex.Store({
  state,
  mutations
})